import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import UserAgentUtils from '../../utils/userAgent';
import { createNotification } from '../NotificationBar/actions';
import ApiUtils from '../../utils/api';
import { getOrFetchDriveItemMeta, viewDriveItem, DriveItemOrigin } from '../DriveItemList/actions';
import { Api } from '../../typings/api';
import { clearSelection, SelectionType } from '../Selection/actions';
import Utils from '../../utils';

enum FolderCreationPanelActionKeys {
	OPEN_PANEL = '@@folderCreationPanel/OPEN_PANEL',
	CLOSE_PANEL = '@@folderCreationPanel/CLOSE_PANEL',
	SET_NAME = '@@folderCreationPanel/SET_NAME',
}

type FolderCreationPanelAction =
	OpenPanelAction |
	ClosePanelAction |
	SetNameAction;

interface OpenPanelAction extends Action {
	type: FolderCreationPanelActionKeys.OPEN_PANEL;
	useSelection: boolean;
}

interface ClosePanelAction extends Action {
	type: FolderCreationPanelActionKeys.CLOSE_PANEL;
}

interface SetNameAction extends Action {
	type: FolderCreationPanelActionKeys.SET_NAME;
	name: string;
}

const openPanel = (useSelection: boolean = false) => (dispatch: Dispatch<StoreState>): void => {
	const action: OpenPanelAction = {
		type: FolderCreationPanelActionKeys.OPEN_PANEL,
		useSelection,
	};
	dispatch(action);
};

const closePanel = () => (dispatch: Dispatch<StoreState>): void => {
	const action: ClosePanelAction = {
		type: FolderCreationPanelActionKeys.CLOSE_PANEL,
	};
	dispatch(action);
};

const setName = (name: string) => (dispatch: Dispatch<StoreState>): void => {
	const action: SetNameAction = {
		type: FolderCreationPanelActionKeys.SET_NAME,
		name: name
	};
	dispatch(action);
};

const createFolder = (name: string, useSelection: boolean) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	const isOnline = await UserAgentUtils.isOnlinePromise();
	const parentFolderId = Utils.getFolderIdForNewResource();

	if (isOnline && parentFolderId) {
		try {
			const { selection: { resources: selectionIds } } = getState();
			const contentIds = useSelection ? selectionIds : [];
			const newFolderId = await ApiUtils.createPrivateFolder(parentFolderId, name, contentIds);
			await dispatch(getOrFetchDriveItemMeta(parentFolderId, true, true, true));
			const newFolderItem = await dispatch(getOrFetchDriveItemMeta(newFolderId)) as Api.DriveItem;
			dispatch(closePanel());
			dispatch(viewDriveItem(newFolderItem, DriveItemOrigin.List));

			if (useSelection) {
				dispatch(clearSelection(SelectionType.RESOURCES));
			}
		} catch (error) {
			dispatch(createNotification('error.cant_create_folder'));
			dispatch(closePanel());
		}

	} else {
		dispatch(createNotification('info.offline_create_folder'));
		dispatch(closePanel());
	}
};

export {
	FolderCreationPanelActionKeys,
	FolderCreationPanelAction,
	createFolder,
	openPanel,
	closePanel,
	SetNameAction,
	setName
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/FolderCreationPanel/actions.ts